import React, { useEffect, useState } from "react";
import "../styles/timer.css";
import { getTimeDifference } from "../utility.js";

let hackathonDate = new Date("April 1, 2023");

function Timer() {
	const [time, setTime] = useState(getTimeDifference(hackathonDate));

	//runs when the component is mounted
	//used to update timer
	useEffect(() => {
		const interval = setInterval(() => {
			setTime(getTimeDifference(hackathonDate));
		}, 1000);

		//runs when the component is unmounted - cleanup function
		return () => clearInterval(interval);
	}, []);

	const getFormattedTime = (time) => {
		const { days, hours, minutes, seconds } = time;
		const timeStr =
			(days.toString().length >= 2 ? days : "0" + days) +
			" : " +
			(hours.toString().length >= 2 ? hours : "0" + hours) +
			" : " +
			(minutes.toString().length >= 2 ? minutes : "0" + minutes) +
			" : " +
			(seconds.toString().length >= 2 ? seconds : "0" + seconds);

		return timeStr;
	};

	//---------------------------------------------------------------------

	return (
		<div className="timer">
			<div className="time">{getFormattedTime(time)}</div>
			<div className="time-labels">
				<div>days</div>
				<div>hours</div>
				<div>minutes</div>
				<div>seconds</div>
			</div>
		</div>
	);
}

export default Timer;
